import { Validator } from '@vista-digital/validator';
export const filmTrailerEventsValidatorSchema = {
    onTrailerLoaded: Validator.optional(Validator.fn()),
    onTrailerFailedToLoad: Validator.optional(Validator.fn()),
    onTrailerError: Validator.optional(Validator.fn()),
    onTrailerClick: Validator.optional(Validator.fn()),
    onTrailerPlay: Validator.optional(Validator.fn()),
    onTrailerPause: Validator.optional(Validator.fn()),
    onTrailerEnded: Validator.optional(Validator.fn())
};
export const filmTrailerEventsValidator = Validator.object(filmTrailerEventsValidatorSchema);
//# sourceMappingURL=events.js.map